import { render, staticRenderFns } from "./AppHead.vue?vue&type=template&id=ac0226bc&scoped=true&"
import script from "./AppHead.vue?vue&type=script&lang=ts&"
export * from "./AppHead.vue?vue&type=script&lang=ts&"
import style0 from "./AppHead.vue?vue&type=style&index=0&id=ac0226bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0226bc",
  null
  
)

component.options.__file = "AppHead.vue"
export default component.exports